<template>
<!-- <div id="app"> -->
<v-app id="inspire" class="CSChatThai" style="overflow-y: hidden;background: white;">
  <v-progress-circular v-if="progress" :size="250" :width="10" style="margin: auto;" indeterminate color="blue"></v-progress-circular>
</v-app>
</template>

<script>
import Navbar from '@/components/home/Navbarapi'
// import NewFooter from '@/components/home/NewFooter'
// import Vue from 'vue'
import {
  Encode,
  Decode
} from '@/services'
// import {
//   sync
// } from 'vuex-pathify'
// import VueSocketio from 'vue-socket.io'
var _ = require('lodash')
export default {
  data() {
    return {
      progress: true,
      code: '',
      status: '',
      passlogin: ''
    }
  },
  // computed: {
  //   ...sync('*')
  // },
  created() {
    this.code = this.$route.query.code
    // this.passlogin = this.$route.query.passlogin
    // if(this.passlogin) {
    // this.getcode()
    if (this.code) {
      this.getcode()
    } else {
      console.log('error: access_denied')
      // https://chat.one.th/login
      this.$router.push('/login')
    }
    // }

  },
  methods: {
    getcode() {
      this.progress = true
      var source = {
        'code': this.code,
        'redirect_uri': process.env.redirect_url
      }
      var addyear = 10
      var newDate = new Date()
      newDate.setTime(newDate.getTime() + (addyear * 365 * 24 * 60 * 60 * 1000))
      var expiresInTime = "expires=" + newDate.toUTCString()
      this.$http.post(process.env.APImanage + '/v2/authorization_code', source).then((response) => {
        this.status = response.data['status']
        this.progress = false
        // console.log(response.data)
        if (this.status === 'success') {
          var profile = response.data['account']['profile']
          // console.log(profile)

          localStorage.setItem('status_login', 'T')
          this.$cookies.set('Myusername', profile['name'])

          this.$store.dispatch('myProfile', profile['profilepicture'])
          localStorage.setItem('profilepicture', profile['profilepicture'])
          this.$store.dispatch('myName', profile['nickname'])
          localStorage.setItem('tokenservice', profile['tokenservice'])
          localStorage.setItem('name', profile['nickname'])
          localStorage.setItem('phone', profile['phone'])
          localStorage.setItem('email', profile['email'])
          localStorage.setItem('status', profile['status'])
          localStorage.setItem('tokenuser', profile['tokenuser'])
          localStorage.setItem('usertype', profile['type'])
          if (profile['profile'] === '' || profile['profile'] === 'None') {
            localStorage.setItem('status_username', 'false')
          } else {
            localStorage.setItem('status_username', 'true')
          }
          if (this.$vuetify.breakpoint.xs == true || this.$vuetify.breakpoint.sm == true) {
            this.$router.push('/mobile/develop/homepage')
          } else {
            this.$router.push('/develop/homepage')
          }
          this.$store.dispatch('tokenRoom', 'noneselect')
          this.$store.dispatch('changeRightTool', 'Friend')
          this.$cookies.set('tokenRoom', 'noneselect')
          localStorage.setItem('room', 'noneselect')
          this.$store.dispatch('changeBot', 'noneselect')
        } else {
          this.$cookie.set('status_login', 'F')
          // document.cookie = "status_login=F;" + expiresInTime + ";"
          this.progress = false
          this.$router.push('/not_found')
        }
      }, (error) => {
        console.log(error)
        this.status = 'fail'
        this.progress = false
        this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.'
      })
    },
    searchFriend(botid) {
      var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
      this.$http.post(process.env.APIsearchfriend, {
        tokenbot: botid,
        tokenuser: decoded.tokenuser
      }).then((response) => {
        // console.log(response.data.listuser)
        if (response.data.listuser.length === 0) {
          localStorage.removeItem('botid_redirect')
          if (window.innerWidth <= 960) {
            this.$router.push('/mobile/homepage')
          } else {
            this.$router.push('/chat')
          }
        } else {
          if (response.data.listuser.relation === 'friend') {
            localStorage.removeItem('botid_redirect')
            if (window.innerWidth <= 960) {
              this.$router.push('/mobile/room/' + response.data.listuser.user.tokenroom)
            } else {
              this.$router.push('/chat/room/' + response.data.listuser.user.tokenroom)
            }
          } else {
            console.log('not friend')
            this.$router.push('/addbot/' + localStorage.getItem('botid_redirect'))
          }
        }
      }).catch(error => {
        console.log(error)
        localStorage.removeItem('botid_redirect')
        if (window.innerWidth <= 960) {
          this.$router.push('/mobile/homepage')
        } else {
          this.$router.push('/chat')
        }
      })
    }
  },
  components: {
    Navbar
  }
}
</script>
<style type="text/css" scoped>
>>>.v-messages__message {
  margin-bottom: 2px;
  margin-top: 2px;
  line-height: 1;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
}

>>>.error--text {
  color: #ff7979 !important;
  caret-color: #ff7979 !important;
}

.forgetpass {
  color: white !important;
  cursor: pointer !important;
}

.forgetpass:hover {
  color: white !important;
  cursor: pointer !important;
  text-decoration: underline !important;
}

a:link {
  text-decoration: none;
  color: white !important;
}

a:visited {
  color: white !important;
  text-decoration: none;
}

a:hover {
  color: #2562af !important;
  text-decoration: none;
}

a:active {
  color: white !important;
  text-decoration: none;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: white !important;
  color: white;
  text-align: center;
}

.footermo {
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #00000000 !important;
  color: white;
  text-align: center;
  margin-top: 20px;
}

.application .theme--light.card,
.theme--light .card {
  background-color: #2562af !important;
}

html,
body {
  overflow: scroll;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.Kanit {
  font-family: 'Kanit', sans-serif !important;
}

.btnloginmobile {
  /* width: 30%; */
  width: 125px !important;
  font-size: 14px;
  color: white !important;
  margin-top: 1vh !important;
  background-color: #2562af !important;
  border: 2px solid white;
  border-radius: 30px;
}

.btnloginmobile:disabled {
  width: 125px !important;
  font-size: 14px;
  /* color: white !important; */
  margin-top: 1vh !important;
  background-color: #5f9cea !important;
  border-radius: 30px;
}

>>>.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat) {
  border-color: #5e9cea !important;
  background-color: #5f9cea !important;
}

.btnregismobile {
  width: 30%;
  font-size: 14px;
  color: #2562af !important;
  margin-top: 1vh !important;
  background-color: #FBFBFF !important;
  border-radius: 10px;
}

.btnloginweb {
  color: white !important;
  width: 40%;
  margin-top: 1vh !important;
  background-color: #2562af !important;
  /*border-radius: 10px;*/
  border: 2px solid white;
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}

.btnregisweb {
  color: #2562af !important;
  width: 40%;
  margin-top: 1vh !important;
  background-color: #FBFBFF !important;
  border-radius: 10px;
  font-family: 'CS ChatThaiUI' !important;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}


>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12) !important;
  border-radius: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/authenCallbackOneid.vue